module.exports = __webpack_public_path__ + "assets/img/img7_1.6d1c77f9.png";